import { useQuery, keepPreviousData, useQueryClient } from '@tanstack/react-query';
import { userQueryKeys } from './userQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { isWoodyError } from '../../errors/errors.utils.js';
import { useAuthStatus } from '@fabric-app/compat';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useCallback } from 'react';

const useQueryUserInfo = (queryOptions) => {
  const { client } = useWoody();
  const authStatus = useAuthStatus();
  return useQuery({
    queryKey: userQueryKeys.userInfo(),
    queryFn: async () => {
      return client.v2("/v2/user/me");
    },
    placeholderData: keepPreviousData,
    refetchInterval: 60 * 1e3 * 5.1,
    staleTime: 60 * 1e3 * 5,
    select: (data) => {
      if (authStatus === "authenticated") {
        return data;
      }
      return void 0;
    },
    retry(failureCount, error) {
      const woodyError = isWoodyError(error) ? error : void 0;
      if (woodyError?.status === 401 && woodyError.detail?.toLowerCase().includes("must be logged in to perform this action") || failureCount > 3) {
        return false;
      }
      return true;
    },
    ...queryOptions,
    enabled: isQueryEnabled([
      authStatus === "authenticated",
      queryOptions?.enabled
    ])
  });
};
const useSetQueryUserInfo = () => {
  const queryClient = useQueryClient();
  return useCallback((data) => {
    queryClient.setQueryData(userQueryKeys.userInfo(), (prevData) => {
      if (!prevData) return prevData;
      return {
        ...prevData,
        ...data
      };
    });
  }, [
    queryClient
  ]);
};

export { useQueryUserInfo, useSetQueryUserInfo };
//# sourceMappingURL=useQueryUserInfo.js.map
